import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFreightGroupItemCompareItem extends Layout {
	sourceEdiCompareItem: DataSource;
	tableCompareItems: Table;
}
